export default __webpack_public_path__ + "static/media/focus-manager.424b40d8.svg";